<template>
  <div
    class="uk-position-relative uk-visible-toggle uk-light"
    tabindex="-1"
    :uk-slideshow="
      `animation: push;autoplay: true;max-height: 300;autoplay-interval: 4000;pause-on-hover: true;ratio: ${this.ratio}`
    "
  >
    <ul class="uk-slideshow-items">
      <li v-for="banner in banners" :key="banner.id">
        <img :src="`${baseUrl}/${banner.path}`" uk-cover />
      </li>
    </ul>
  </div>
</template>
<script>
import Configuration from '@/configuration'
const baseUrl = Configuration.value('apiUrl')
export default {
  props: {
    banners: {
      type: Array,
      required: true
    },
    ratio: {
      type: String,
      required: false,
      default: '16:9'
    }
  },
  data() {
    return {
      baseUrl: baseUrl
    }
  }
}
</script>
